import { Component, Injector, OnInit } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-customer-billing-navigation-tabs',
    templateUrl: './customer-billing-navigation-tabs.component.html',
    styleUrls: ['./customer-billing-navigation-tabs.component.scss'],
    standalone: false,
})
export class CustomerBillingNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.tabs = [
            {
                Title: this.appTextService.get('common.customers'),
                Sref: FiStateNames.CustomerBilling.Customers.List,
            },
            {
                Title: this.appTextService.get('customer_billing.customer_units'),
                Sref: FiStateNames.CustomerBilling.CustomerUnits.List,
            },
            {
                Title: this.appTextService.get('customer_billing.invoices'),
                Sref: FiStateNames.CustomerBilling.Invoice.List,
                AddState: FiStateNames.CustomerBilling.Invoice.Add,
            },
            {
                Title: this.appTextService.get('customer_billing.other_customers'),
                Sref: FiStateNames.CustomerBilling.OtherCustomers.List,
                AddState: FiStateNames.CustomerBilling.OtherCustomers.Add,
            },
            {
                Title: this.appTextService.get('customer_billing.resellers'),
                Sref: FiStateNames.CustomerBilling.Resellers.List,
                AddState: FiStateNames.CustomerBilling.Resellers.Add,
            },
            {
                Title: this.appTextService.get('customer_billing.price_list'),
                Sref: FiStateNames.CustomerBilling.Price.List,
                AddState: FiStateNames.CustomerBilling.Price.Add,
            },
        ];
        super.updateSelectedTabFromState(true);
    }
}
